import React, { CSSProperties } from "react";
import { Box } from "@mui/material";
import { renderNodeContent } from "./RenderNodeContent";

function getStyleForDepth(depth: number): CSSProperties {
  if (depth === 0) {
    return {
      display: "flex",
      flexDirection: "column",
      gap: "1.5rem",
    };
  }
  return {};
}

export function TreeNodeIndent(props: { data: { [key: string]: any }; depth: number; path: string[] }) {
  return <Box style={getStyleForDepth(props.depth)}>{renderNodeContent(props.data, props.depth, props.path)}</Box>;
}
